<ngx-loading [show]="isProcessing"></ngx-loading>

<div class="row">
  <div class="col-md-12">
    <table class="table table-bordered">
      <tbody>
        <tr>
          <td rowspan="2" class="vam wf120">
            Grupo local
            <div
              class="spinner-border text-light"
              role="status"
              *ngIf="isLoadingGruposLocais"
            >
              <span class="sr-only">Loading...</span>
            </div>
          </td>

          <td
            colspan="3"
            *ngIf="tipoInstalacaoApp == 'SS'"
            class="tipo vam"
            style="vertical-align: middle"
            (click)="selecionarTipo($event, 'SS')"
          >
            SS
          </td>
          <td
            colspan="3"
            *ngIf="tipoInstalacaoApp == 'PT'"
            class="tipo vam"
            style="vertical-align: middle"
            (click)="selecionarTipo($event, 'PT')"
          >
            PT
          </td>

          <td
            *ngIf="tipoInstalacaoApp == 'SSPT'"
            class="tipo vam"
            style="vertical-align: middle"
            (click)="selecionarTipo($event, 'SS')"
          >
            SS
          </td>
          <td
            *ngIf="tipoInstalacaoApp == 'SSPT'"
            class="tipo vam"
            style="vertical-align: middle"
            (click)="selecionarTipo($event, 'PT')"
          >
            PT
          </td>
          
          <td
          *ngIf="tipoInstalacaoApp == 'SSPT'"
          class="tipo vam wf70"
          style="vertical-align: middle"
          (click)="selecionarTipo($event, 'SS_PT')"
          >
          SS + PT
          </td>
          <td class="vam wf250">
            <div class="btn-group">
              <button type="button" 
              class="btn" 
              [ngClass]="{'btn-info' : this.parameters.periodo === 'periodoAno', 'btn-secondary': this.parameters.periodo !== 'periodoAno'}"  
              (click)="setFilterTime('periodoAno')"
              >Ano
            </button>
            <button type="button" 
            class="btn" 
            [ngClass]="{'btn-info' : this.parameters.periodo === 'periodoDatas', 'btn-secondary': this.parameters.periodo !== 'periodoDatas'}" 
            title="Período de data" (click)="setFilterTime('periodoDatas')">Período</button>
            </div>

          </td>
          
          <td
            colspan="6"
            class="periodo vam"
            (click)="selecionarPeriodo($event, '1,2,3,4,5,6', '01-01')"
          >
            1º SEMESTRE
          </td>
          <td
            colspan="6"
            class="periodo vam"
            (click)="selecionarPeriodo($event, '7,8,9,10,11,12', '06-01')"
          >
            2º SEMESTRE
          </td>
          
          <!--  <td rowspan="3" class="pl-3 pr-3 bg-info vam" (click)="getDashboard()" title="Atualizar dashboard"><i
              class="pe-7s-refresh-2 fwn"></i></td> -->
        </tr>


        
        <tr>
          <td colspan="3" class="tipo vam" (click)="selecionarTipo($event, 'PBM')" style="height: 58px; ">
            PREVENTIVA
          </td>
          <td rowspan="2" style="vertical-align: middle;" *ngIf="this.parameters.periodo === 'periodoAno'">
            <div class="input-group">

            <input
              type="text"
              class="form-control text-center"
              id="ano"
              [value]="this.parameters.ano"
              digitOnly
              maxlength="4"
              [ngClass]="{'h-error' : this.validacoes.ano != ''}"
            />
         
            <div class="input-group-append cp" 
				
            (click)="selecionarAno()">
            <span class="input-group-text">OK</span>
          </div>
          
            </div>
            <span *ngIf="this.validacoes.ano != ''" class="text-danger">{{this.validacoes.ano}}</span>
            

          </td>
          <td *ngIf="this.parameters.periodo === 'periodoDatas'">
            <input type="date" placeholder="Data Inicio" 
            class="form-control" 
            id="dataInicial" 
            max="2999-12-31"
            [value]="this.parameters.dataInicial"
            [ngClass]="{'h-error' : this.validacoes.dataInicial != ''}"
            >
            <span *ngIf="this.validacoes.dataInicial" class="text-danger">{{this.validacoes.dataInicial}}</span>
          </td>
          
          <td
            colspan="3"
            class="periodo vam"
            (click)="selecionarPeriodo($event, '1,2,3', '01-01')"
          >
            1º TRIM
          </td>
          <td
            colspan="3"
            class="periodo vam"
            (click)="selecionarPeriodo($event, '4,5,6', '04-01')"
          >
            2º TRIM
          </td>
          <td
            colspan="3"
            class="periodo vam"
            (click)="selecionarPeriodo($event, '7,8,9', '07-01')"
          >
            3º TRIM
          </td>
          <td
            colspan="3"
            class="periodo vam"
            (click)="selecionarPeriodo($event, '10,11,12', '10-01')"
          >
            4º TRIM
          </td>
         
        </tr>
        <tr>
          <td>
            <select
              class="form-control"
              (change)="changeGrupoLocal($event.target.value)"
              [ngClass]="{ 'bg-info': this.parameters.grupoLocalNivel1Id > 0 }"
              tabindex="-1"
            >
              <option value="">Todos</option>
              <option *ngFor="let item of this.gruposLocais" [value]="item.id">
                {{ item.nome }}
              </option>
            </select>
          </td>
          <td
            colspan="3"
            class="tipo bg-info vam"
            (click)="selecionarTipo($event, 'TODOS')"
          >
            TODOS
          </td>
          <td *ngIf="this.parameters.periodo === 'periodoDatas'"> 
            <div class="input-group">

              <input type="date" 
              placeholder="Data Término" 
              class="form-control" 
              id="dataFinal" 
              max="2999-12-31" 
              [value]="this.parameters.dataFinal"
              [ngClass]="{'h-error' : this.validacoes.dataFinal != ''}"
              >
              <div class="input-group-append cp" 
				
              (click)="selecionarDatas()">
              <span class="input-group-text">OK</span>
            </div>

            </div>
            <span *ngIf="this.validacoes.dataFinal" class="text-danger">{{this.validacoes.dataFinal}}</span>
          </td>
         
          <td class="periodo mes vam" (click)="selecionarPeriodo($event, '1', '01-01')">
            JAN
          </td>
          <td class="periodo mes vam" (click)="selecionarPeriodo($event, '2', '02-01')">
            FEV
          </td>
          <td class="periodo mes vam" (click)="selecionarPeriodo($event, '3', '03-01')">
            MAR
          </td>
          <td class="periodo mes vam" (click)="selecionarPeriodo($event, '4', '04-01')">
            ABR
          </td>
          <td class="periodo mes vam" (click)="selecionarPeriodo($event, '5', '05-01')">
            MAI
          </td>
          <td class="periodo mes vam" (click)="selecionarPeriodo($event, '6', '06-01')">
            JUN
          </td>
          <td class="periodo mes vam" (click)="selecionarPeriodo($event, '7', '07-01')">
            JUL
          </td>
          <td class="periodo mes vam" (click)="selecionarPeriodo($event, '8', '08-01')">
            AGO
          </td>
          <td class="periodo mes vam" (click)="selecionarPeriodo($event, '9', '09-01')">
            SET
          </td>
          <td class="periodo mes vam" (click)="selecionarPeriodo($event, '10', '10-01')">
            OUT
          </td>
          <td class="periodo mes vam" (click)="selecionarPeriodo($event, '11', '11-01')">
            NOV
          </td>
          <td class="periodo mes vam" (click)="selecionarPeriodo($event, '12', '12-01')">
            DEZ
          </td>
         
          
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="row">
  <div class="col-md-6 mb-2">
    <div class="numeros">
      <div class="numeros-title">
        Ordens de serviço {{ this.typeChart01 == 'bar' ? " executadas" : " executadas"}} por classificação 
        <span *ngIf="this.dashboard?.qtdeRealizadas > 0" class="pl-2">
            ({{this.dashboard?.qtdeRealizadas}} OSs)
        </span>
      </div>
      <section id="chart01" style="min-height: 370px; max-height: 370px">
        <div class="type-charts">
          <button type="button" class="btn">
            <span
              class="fa fa-bar-chart fa-lg"
              [ngClass]="{ 'txt-blue': this.typeChart01 == 'bar' }"
              (click)="changeTypeChart01('bar')"
            >
            </span>
          </button>
          <button type="button" class="btn">
            <span
              class="fa fa-pie-chart fa-lg"
              [ngClass]="{ 'txt-blue': this.typeChart01 == 'pie' }"
              (click)="changeTypeChart01('pie')"
            >
            </span>
          </button>
        </div>
        <div class="numeros-body" style="min-height: 370px; max-height: 370px">
          <apx-chart
            *ngIf="this.optionsChartOSClassificacao != null"
            [series]="this.optionsChartOSClassificacao?.series"
            [chart]="this.optionsChartOSClassificacao?.chart"
            [labels]="this.optionsChartOSClassificacao?.labels"
            [dataLabels]="this.optionsChartOSClassificacao?.dataLabels"
            [autoUpdateSeries]="this.optionsChartOSClassificacao?.autoUpdateSeries"
            [xaxis]="this.optionsChartOSClassificacao?.xaxis"
            [yaxis]="this.optionsChartOSClassificacao?.yaxis"
            [plotOptions]="this.optionsChartOSClassificacao?.plotOptions"
          ></apx-chart>
        </div>
      </section>
    </div>
  </div>

  <div class="col-md-6">
    <div class="numeros">
      <div class="numeros-title">
        Ordens de serviço {{ this.typeChart02 == 'bar' ? " executadas" : " executadas"}} por área técnica
        <span *ngIf="this.dashboard?.qtdeRealizadas > 0" class="pl-2">
          ({{this.dashboard?.qtdeRealizadas}} OSs)
      </span>
      </div>

      <section id="chart02" style="min-height: 370px; max-height: 370px">
        <div class="type-charts">
          <button type="button" class="btn">
            <span
              class="fa fa-bar-chart fa-lg"
              [ngClass]="{ 'txt-blue': this.typeChart02 == 'bar' }"
              (click)="changeTypeChart02('bar')"
            >
            </span>
          </button>
          <button type="button" class="btn">
            <span
              class="fa fa-pie-chart fa-lg"
              [ngClass]="{ 'txt-blue': this.typeChart02 == 'pie' }"
              (click)="changeTypeChart02('pie')"
            >
            </span>
          </button>
        </div>



      <div
        class="numeros-body"
        *ngIf="
          this.dashboard?.areasTecnicas != undefined &&
          this.dashboard?.areasTecnicas != null
        "
        
      >
        
        <apx-chart
            *ngIf="this.optionsChartOSAreaTecnica != null"
            [series]="this.optionsChartOSAreaTecnica?.series"
            [chart]="this.optionsChartOSAreaTecnica?.chart"
            [labels]="this.optionsChartOSAreaTecnica?.labels"
            [dataLabels]="this.optionsChartOSAreaTecnica?.dataLabels"
            [autoUpdateSeries]="this.optionsChartOSAreaTecnica?.autoUpdateSeries"
            [xaxis]="this.optionsChartOSAreaTecnica?.xaxis"
            [yaxis]="this.optionsChartOSAreaTecnica?.yaxis"
            [plotOptions]="this.optionsChartOSAreaTecnica?.plotOptions"
            [colors]="this.optionsChartOSAreaTecnica?.colors"
          ></apx-chart>

      </div>
    </section>
    </div>
  </div>
</div>


<div class="divider"></div>

<div class="row">

      <div class="col-md-4 text-center mb-2">
        <div class="numeros">
          <div class="numeros-title">
            <span [innerHtml]="tituloCardResumo3"></span>
          </div>
          <div class="numeros-body">
            <h3>
              <span class="count-up-wrapper">{{ this.valorCardResumo3 }}</span>
            </h3>
          </div>
        </div>
      </div>

      <div class="col-md-4 text-center mb-2">
        <div class="numeros">
          <div class="numeros-title">
            <span>OSs Executadas<br />no período</span>
          </div>
          <div class="numeros-body text-center">
            <h3>
              <span class="count-up-wrapper">{{this.dashboard?.qtdeRealizadas}}</span>
            </h3>
          </div>
        </div>
      </div>

      <div class="col-md-4 text-center mb-2">
        <div class="numeros">
          <div class="numeros-title">
            <span>% Criadas / Executadas<br />no período</span>
          </div>
          <div class="numeros-body">
            <h3>
              <span class="count-up-wrapper">{{ this.valorCardResumo4 }}</span>
            </h3>
          </div>
        </div>
      </div>
      
</div>

<div class="divider"></div>

<div class="row">
  <div
    [ngClass]="{
      'col-md-4': this.exibirQuadroFalhasEmDashboard,
      'col-md-6': !this.exibirQuadroFalhasEmDashboard
    }"
    class="mb-2"
  >
    <div class="numeros">
      <div class="numeros-title">Pendências detectadas no período</div>
      <div
        class="numeros-body"
        *ngIf="
          this.optionsChartPendencias != undefined &&
          this.optionsChartPendencias != null
        "
      >
        <apx-chart
          [series]="this.optionsChartPendencias?.series"
          [chart]="this.optionsChartPendencias?.chart"
          [plotOptions]="this.optionsChartPendencias?.plotOptions"
          [xaxis]="this.optionsChartPendencias?.xaxis"
          [dataLabels]="this.optionsChartPendencias?.dataLabels"
        ></apx-chart>
      </div>
    </div>
  </div>

  <div class="col-md-4" *ngIf="this.exibirQuadroFalhasEmDashboard" class="mb-2">
    <div class="numeros">
      <div class="numeros-title">Falhas detectadas no período</div>
      <div
        class="numeros-body"
        *ngIf="
          this.optionsChartFalhas != undefined &&
          this.optionsChartFalhas != null
        "
      >
        <apx-chart
          [series]="this.optionsChartFalhas?.series"
          [chart]="this.optionsChartFalhas?.chart"
          [plotOptions]="this.optionsChartFalhas?.plotOptions"
          [xaxis]="this.optionsChartFalhas?.xaxis"
          [dataLabels]="this.optionsChartFalhas?.dataLabels"
        >
        </apx-chart>
      </div>
    </div>
  </div>

  <div
    [ngClass]="{
      'col-md-4': this.exibirQuadroFalhasEmDashboard,
      'col-md-6': !this.exibirQuadroFalhasEmDashboard
    }"
    class="mb-2"
  >
    <div class="numeros">
      <div class="numeros-title">
        Ranking dos 10 locais mais visitados no período
      </div>
      <div
        class="numeros-body"
        *ngIf="
          this.optionsChartLocais != undefined &&
          this.optionsChartLocais != null
        "
      >
        <apx-chart
          [series]="this.optionsChartLocais?.series"
          [chart]="this.optionsChartLocais?.chart"
          [plotOptions]="this.optionsChartLocais?.plotOptions"
          [xaxis]="this.optionsChartLocais?.xaxis"
          [dataLabels]="this.optionsChartLocais?.dataLabels"
        >
        </apx-chart>
      </div>
    </div>
  </div>
</div>



<div class="divider"></div>

<div class="row">

      <div class="col-md-4 text-center mb-2">
        <div class="numeros-destaque">
          <div class="numeros-title-destaque">
            <span>Serviços em aberto<br />(anteriores ao periodo)</span>
          </div>
          <div class="numeros-body">
            <h3>
              <span class="count-up-wrapper">{{ this.valorAntesPeriodo }}</span>
            </h3>
          </div>
        </div>
      </div>

      <div class="col-md-4 text-center mb-2">
        <div class="numeros-destaque">
          <div class="numeros-title-destaque">
            <span [innerHtml]="this.tituloCardResumo1"></span>
          </div>
          <div class="numeros-body">
            <h3>
              <span class="count-up-wrapper">{{ this.valorCardResumo1 }}</span>
            </h3>
          </div>
        </div>
      </div>
     
      <div class="col-md-4 text-center mb-2">
        <div class="numeros-destaque">
          <div class="numeros-title-destaque">
            <span>Total de serviços<br />(serviços em potencial)</span>
          </div>
          <div class="numeros-body">
            <h3>
              <span class="count-up-wrapper">{{ this.valorBolsaPeriodo }}</span>
            </h3>
          </div>
        </div>
      </div>

</div>

<div class="divider"></div>

<!-- detalhamento dos valores -->

<label>Ver detalhamento dos valores<span class="pr-2"></span>
  <input
    type="checkbox"
    ng-model="checked"
    ng-init="checked=true"
    (change)="this.showDetails = $event.target.checked"
    style="height: 15px; width: 15px;"
    class="cp"
  />
</label>

<div class="divider"></div>

<!-- <div class="detalhamento" *ngIf="flexCheckDefault.checked"> -->

<!-- Alexandre. Se abaixo eu alterno para true, aparece normalmente o trecho do DIV
     o problema é como trocar o "false" ou o "true" por algo dinâmico, que reaja ao
     marcar ou desmarcar do checkbox. Sei que é algo básico para você, mas para mim
     faltam conceitos que estão me impedindo de identificar o que estaria faltando

     Mudança alternativa:
     <label>Ver detalhamento dos valores<span class="pr-2"></span>
  <input
    type="checkbox"
    ng-model="checked"
    ng-init="checked=true"
    #flexCheckDefault
    (change)="this.showDetails = flexCheckDefault.checked"
    style="height: 15px; width: 15px;"
    class="cp"
  />
</label>

     
-->

<div *ngIf="this.showDetails"  class="animated fadeInDown">   

  <div class="card">
    <div class="card-header">
      Detalhamento de valores antes do período
    </div>

    <div class="card-body">
      <div class="row">
        <div class="col-2"><span>SPVs Geradas Ant:</span></div>
        <div class="col-2 fb"><span>{{this.dashboard?.qtdeSPVsGeradasAnt}}</span></div>

        <div class="col-2"><span>PTs Geradas Ant:</span></div>
        <div class="col-2 fb"><span>{{this.dashboard?.qtdePTsGeradasAnt}}</span></div>

        <div class="col-2"><span>OSs Geradas Ant:</span></div>
        <div class="col-2 fb"><span>{{this.dashboard?.qtdeOSsGeradasAnt}}</span></div>
    </div>
  </div>

  <div class="divider"></div>

  <div class="card ">
    <div class="card-header">
      Detalhamento de valores dentro do período
    </div>

    <div class="card-body">
      <div class="row">
        <div class="col-2"><span>SPVs Geradas:</span></div>
        <div class="col-2 fb"><span>{{this.dashboard?.qtdeSPVsGeradas}}</span></div>

        <div class="col-2"><span>SPVs Aprovadas:</span></div>
        <div class="col-2 fb"><span>{{this.dashboard?.qtdeSPVsAprovadas}}</span></div>

        <div class="col-2"><span>PTs Geradas:</span></div>
        <div class="col-2 fb"><span>{{this.dashboard?.qtdePTsGeradas}}</span></div>
      </div>
    </div>
  </div>

  <div class="divider"></div>

  <div class="card ">
    <div class="card-header">
      Separação entre OSs prev. e corretivas
    </div>

    <div class="card-body">
      <div class="row">
        <div class="col-2"><span>Prev. Geradas:</span></div>
        <div class="col-2 fb"><span>{{this.dashboard?.qtdePBMsGeradas}}</span></div>

        <div class="col-2"><span>OSs Geradas:</span></div>
        <div class="col-2 fb"><span>{{this.dashboard?.qtdeOSsGeradas}}</span></div>
      </div>
    </div>
  </div>

  <div class="divider"></div>

  <div class="card ">
    <div class="card-header">
      Outros Valores referentes às OSs
    </div>

    <div class="card-body">
      <div class="row">
        <div class="col-2"><span>OSs Fechadas:</span></div>
        <div class="col-2 fb"><span>{{this.dashboard?.qtdeOSsFechadas}}</span></div>

        <div class="col-2"><span>OSs Realizadas:</span></div>
        <div class="col-2 fb"><span>{{this.dashboard?.qtdeRealizadas}}</span></div>
      </div>
    </div>
  </div>

</div>
<!-- FIM detalhamento dos valores -->

<div class="divider"></div>